import React from "react";

interface ImageWithCaptionProps {
  caption: string;
  children: React.ReactNode;
}

export const ImageWithCaption: React.FC<ImageWithCaptionProps> = ({
  caption,
  children,
}) => (
  <figure className="flex w-full flex-col items-center gap-2 rounded border border-gray-200 bg-gray-50 p-4">
    <div className="w-full overflow-hidden rounded">{children}</div>
    <figcaption className="text-text-tertiary w-full text-left text-sm">
      {caption}
    </figcaption>
  </figure>
);
